module.exports = [{
      plugin: require('/opt/build/repo/gatsby/node_modules/gatsby-plugin-catch-links/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/opt/build/repo/gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
